import { srSpeak } from "./srSpeak";
import { focus } from "./focus";
import { otto } from "../../exports/nexus";

otto.ally.assignNamespace({
  srSpeak,
  focus,
});
